<freud-dialog
	[(visible)]="isOpen"
	(visibleChange)="!$event && onClose.emit()"
	[draggable]="false"
	[modal]="true"
>
	<div class="header">
		<div class="header__title">{{ recurrencyAttempt.contactName }}</div>
		<div class="header__actions">
			<span
				*ngIf="recurrencyAttempt.profileId"
				(click)="openChat()"
				class="freud-icon freud-icon-messages"
			></span>
			<span
				(click)="goToContactPage()"
				class="freud-icon freud-icon-user"
			></span>
		</div>
	</div>
	<div class="body">
		<div class="info-card">
			<span class="freud-icon freud-icon-bulb"></span>
			<div>
				<span class="zk-mr-1" [innerHTML]="formattedCard"></span>
				<a
					target="_blank"
					rel="noopener"
					href="https://hs-info.zenklub.com/pt-br/faq/sess%C3%B5es-recorrentes-n%C3%A3o-agendadas-no-zenoffice-web"
					>{{ 'RECURRENCY_ATTEMPT.KNOW_MORE' | translate }}.</a
				>
			</div>
		</div>
		<div class="info">
			<span class="info-label"
				>{{ 'RECURRENCY_ATTEMPT.STATUS' | translate }}:</span
			>
			<span>{{ 'RECURRENCY_ATTEMPT.RECURRENCY_STATUS' | translate }}</span>
		</div>
		<div class="info">
			<span class="info-label"
				>{{ 'RECURRENCY_ATTEMPT.WHEN_WOULD_IT_HAPPEN' | translate }}:</span
			>
			<span>{{ formattedDate }}</span>
		</div>
		<div class="info">
			<span class="info-label"
				>{{ 'RECURRENCY_ATTEMPT.REASON' | translate }}:</span
			>
			<span>{{ formattedMotive }}</span>
		</div>
	</div>
	<ng-container freudTemplatefooter>
		<div
			class="zk-flex"
			*ngIf="recurrencyAttempt.reason === 'ProfessionalHasNoAvailability'"
		>
			<freud-button (click)="sendInvite()" [color]="'secondary'">{{
				'RECURRENCY_ATTEMPT.SEND_INVITE' | translate
			}}</freud-button>
			<freud-button (click)="goToAvailabilities()">{{
				'RECURRENCY_ATTEMPT.EDIT_AVAILABILITIES' | translate
			}}</freud-button>
		</div>
		<div
			class="zk-flex"
			*ngIf="
				recurrencyAttempt.reason === 'ProfessionalHasBlockedAvailability' &&
				recurrencyAttempt.blockedType === 'Appointment'
			"
		>
			<freud-button (click)="openChat()">{{
				'RECURRENCY_ATTEMPT.SEND_INVITE_BY_CHAT' | translate
			}}</freud-button>
		</div>
		<div
			class="zk-flex"
			*ngIf="
				recurrencyAttempt.reason === 'ProfessionalHasBlockedAvailability' &&
				recurrencyAttempt.blockedType === 'BusySlot'
			"
		>
			<freud-button (click)="sendInvite()">{{
				'RECURRENCY_ATTEMPT.SEND_INVITE' | translate
			}}</freud-button>
		</div>
	</ng-container>
</freud-dialog>
